import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
  useRef,
} from "react";
import debounce from "lodash/debounce";
import styled from "styled-components";
import { alertpagetext } from "variables/alerts";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getAlerts } from "services/ConfigServices";
import CustomSwitch from "components/Input/CustomSwitch.js";

const StyledTextField = styled.input`
height: 32px;
width: 200px;
border-radius: 3px;
border-top-left-radius: 5px;
border-bottom-left-radius: 5px;
border-top-right-radius: 0;
border-bottom-right-radius: 0;
border: 1px solid #e5e5e5;
padding: 0 32px 0 16px;

&:hover {
  cursor: pointer;
}
`;

const TableName = styled.h1`
margin-right: auto;
margin-left: -8px;
font-size: 1.3rem;
font-weight: 500;
`;

export default function useAlertsTableQuery() {
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [sorted, setSorted] = useState();
  const [filtered, setFiltered] = useState();
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [dbValue, setDbValue] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [avoidLoading, setAvoidLoading] = useState(false);
  const [hideclosed, setHideclosed] = useState(true);

  //Can change : pageSize, page, column, sortDirection, chartIdGroup, dbvalue

  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if (!avoidLoading)
        setLoading(true);
      setAvoidLoading(false);
      async function fetchData() {
        const response = await axios.get(
          getAlerts(chartIdGroup, pageSize, page, sorted, dbValue, null, hideclosed),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setData(response.data.collection);
        setTotalRows(response.data.meta.count);
        setLoading(false);
      }
      fetchData();
    }
  }, [dbValue, page, pageSize, chartIdGroup, sorted, refresh, hideclosed]);

  const handlePerRowsChange = (pageSize, page) => {
    setPageSize(pageSize);
    setPage(page);
    console.log('pagesize', page, pageSize);
  };
  const handlePageChange = (page) => {
    setPage(page);
  };
  const handleSort = (column, sortDirection) => {
    let sortObject = {
      name: column.key,
      sort: sortDirection
    };
    setSorted(sortObject);
  };
  const handleHideclosedChange = (event) => {
    setHideclosed(!hideclosed);
  };


  // ----------------------------------------------------------



  const request = debounce((value) => {
    setDbValue(value);
  }, 350);

  const debouceRequest = useCallback((value) => request(value), []);

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus={true}
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const subHeaderComponentMemo = useMemo(() => {

    const onFilterText = (e) => {
      const { value: nextValue } = e.target;
      setFilterText(nextValue);
      const newValue = nextValue;
      debouceRequest(newValue);
    };

    return (
      <>
        <CustomSwitch
          style={{ margin: "10px 40px 0 3px" }}
          inputTitle={alertpagetext.hideclosed}
          checkedState={hideclosed}
          handleSwitchChange={handleHideclosedChange}
        />
        <FilterComponent
          key="FilterComponent"
          filterText={filterText}
          onFilter={onFilterText}
        />
      </>
    );
  }, [filterText, hideclosed]);






  return {
    gridState: {
      defaultPageSize: 20,
      data: data,
      paginationTotalRows: totalRows,
      onChangeRowsPerPage: handlePerRowsChange,
      onChangePage: handlePageChange,
      filterable: true,
      manual: true,
      onSort: handleSort,
      subHeaderComponent: subHeaderComponentMemo,
      loading: loading,
    },
    setRefresh,
    refresh,
    setData,
    setAvoidLoading
    //error,
    //refetch,
    //invalidate,
  };
}
